import React, { useState } from 'react';
import { Typography, Card, Row, Col, Space } from 'antd';

const { Title, Text } = Typography;

function DocsAdmin() {
  return (
    <div style={{ padding: '24px' }}>
      <Title level={2}>Documentation</Title>

      <Row gutter={[24, 24]}>
        <Col xs={24} md={12}>
          <Card title="Getting Started">
            <Space direction="vertical">
              <Title level={4}>Quick Start Guide</Title>
              <Text>Learn how to set up and manage your city guide platform.</Text>
            </Space>
          </Card>
        </Col>

        <Col xs={24} md={12}>
          <Card title="Content Management">
            <Space direction="vertical">
              <Title level={4}>Managing Content</Title>
              <Text>Learn how to add and manage places, events, tours, and categories.</Text>
            </Space>
          </Card>
        </Col>

        <Col xs={24} md={12}>
          <Card title="Subscription Management">
            <Space direction="vertical">
              <Title level={4}>Billing & Subscriptions</Title>
              <Text>Understand billing, subscriptions, and payment processing.</Text>
            </Space>
          </Card>
        </Col>

        <Col xs={24} md={12}>
          <Card title="Technical Documentation">
            <Space direction="vertical">
              <Title level={4}>API Reference</Title>
              <Text>Technical documentation for developers and integrators.</Text>
            </Space>
          </Card>
        </Col>
      </Row>
    </div>
  );
}

export default DocsAdmin;
